/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class PreferencesApi {
  async GetUserPreferences() : Promise<st.UserPreferences> {
    return await componentApi.call('st', 'preferences-api', 'PreferencesApi', 'GetUserPreferences', {
    });
  }
  async UpdateUserPreference(param : string, value : string) : Promise<any> {
    return await componentApi.call('st', 'preferences-api', 'PreferencesApi', 'UpdateUserPreference', {
      param,
      value,
    });
  }
}
export default new PreferencesApi()
